import { Box, Typography } from "@mui/material";
import React from "react";
import MainNavBar from "../../../layout/pages/navbar/MainNavBar";
import { ReactComponent as PNG404 } from "../../../../assets/svg/humcart_404.svg";

const PageNotFound: React.FC = () => {
  return (
    <>
      <MainNavBar />
      <Box
        sx={{
          height: "80vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          width:"100%"
        }}
      >
        {/* <Typography
          sx={{
            fontSize: "200px",
            fontFamily: "Monospace",
            fontWeight: "bold",
            color: "orangered",
          }}
        >
          404
        </Typography> */}
        <Box sx={{maxWidth:"500px", width:{xs:"250px",md:"350px"}, display:"flex",justifyContent:"center"}}>
          <PNG404 />
        </Box>
        <Typography
          sx={{
            fontSize: "27px",
            fontFamily: "Poppins",
            fontWeight: "bold",
            color: "red",
            my:1,
            py:1
          }}
        >
          PAGE NOT FOUND!
        </Typography>
      </Box>
    </>
  );
};

export default PageNotFound;
